module.exports = __webpack_public_path__ + "static/media/NoData-Results.276afd71.svg";